// proteoformTokens.ts
// Canonical isoform/PTM token set + display order for the Tau proteoform matrix.
// Mirrors TAU_STUB_COLUMNS (TauSamplesDetailTable.tsx) and the stub columns in
// RunSampleDetailsSection/colDefs.ts. `token` is the segment as it appears inside
// the composite `proteoform_name` (e.g. "N-0N-pT205-3R-C"); `i18nKey` is the existing
// `runs`-namespace key used for the localized column header.
// TODO(backend): the canonical token set + ordering should come from the API, not a
// hardcoded constant. Confirm whether the matrix PTM segment is "p217" or "pT217" in
// proteoform_name (TauSamplesDetailTable uses "p217"; the i18n value reads "pT217").
export interface ProteoformToken {
  token: string;
  i18nKey: string;
}

export const PROTEOFORM_TOKENS: readonly ProteoformToken[] = [
  { token: 'N', i18nKey: 'sampleDetails.col_n_terminus' },
  { token: '0N', i18nKey: 'sampleDetails.col_0n' },
  { token: '1N', i18nKey: 'sampleDetails.col_1n' },
  { token: '2N', i18nKey: 'sampleDetails.col_2n' },
  { token: '3R', i18nKey: 'sampleDetails.col_3r' },
  { token: '4R', i18nKey: 'sampleDetails.col_4r' },
  { token: 'C', i18nKey: 'sampleDetails.col_c_terminus' },
  { token: 'pT181', i18nKey: 'sampleDetails.col_pt181' },
  { token: 'pS202+PT205', i18nKey: 'sampleDetails.col_ps202_pt205' },
  { token: 'pT205', i18nKey: 'sampleDetails.col_pt205' },
  { token: 'pS214', i18nKey: 'sampleDetails.col_ps214' },
  { token: 'p217', i18nKey: 'sampleDetails.col_pt217' },
  { token: 'pT231', i18nKey: 'sampleDetails.col_pt231' },
  { token: 'pS396', i18nKey: 'sampleDetails.col_ps396' },
] as const;
